var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 10.6875C16.8107 10.6875 17.0625 10.9393 17.0625 11.25C17.0625 14.4632 14.4632 17.0625 11.25 17.0625C11.0473 17.0625 10.8604 16.9535 10.7605 16.7771C10.6607 16.6008 10.6634 16.3844 10.7677 16.2106L11.5551 14.8981C11.715 14.6317 12.0605 14.5453 12.3269 14.7052C12.5933 14.865 12.6797 15.2105 12.5198 15.4769L12.3163 15.816C14.3932 15.3342 15.9375 13.4749 15.9375 11.25C15.9375 10.9393 16.1893 10.6875 16.5 10.6875Z",
    fill: "#235643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68365 2.18395C3.60683 2.66577 2.0625 4.52506 2.0625 6.75C2.0625 7.06066 1.81066 7.3125 1.5 7.3125C1.18934 7.3125 0.9375 7.06066 0.9375 6.75C0.9375 3.53684 3.53684 0.9375 6.75 0.9375C6.95265 0.9375 7.13964 1.04651 7.23949 1.22286C7.33933 1.3992 7.3366 1.61563 7.23234 1.7894L6.44485 3.1019C6.28502 3.36829 5.9395 3.45467 5.67311 3.29484C5.40672 3.13501 5.32034 2.78949 5.48017 2.5231L5.68365 2.18395Z",
    fill: "#235643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 11.775V12.2325H1.5V11.775C1.5 10.455 1.83 10.125 3.165 10.125H7.335C8.67 10.125 9 10.455 9 11.775Z",
    fill: "#235643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.2324V13.3574V14.8499C1.5 16.1699 1.83 16.4999 3.165 16.4999H7.335C8.67 16.4999 9 16.1699 9 14.8499V13.3574V12.2324H1.5Z",
    fill: "#235643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.5 3.15V3.6075H9V3.15C9 1.83 9.33 1.5 10.665 1.5H14.835C16.17 1.5 16.5 1.83 16.5 3.15Z",
    fill: "#235643"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.60742V4.73242V6.22492C9 7.54492 9.33 7.87492 10.665 7.87492H14.835C16.17 7.87492 16.5 7.54492 16.5 6.22492V4.73242V3.60742H9Z",
    fill: "#235643"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertCard);
export default __webpack_public_path__ + "static/media/convert-card.9ec8c1a0a513390d092a6bcf41b9dfeb.svg";
export { ForwardRef as ReactComponent };